import { Badge, IconButton, SvgIcon, Tooltip } from "@mui/material";
import type React from "react";
import { Settings as SettingsIcon } from "react-feather";
import { useHistory } from "react-router-dom";

import useSettings from "src/hooks/useSettings";
import { PATH_POS_LIST, PATH_POS_PARAMETER } from "src/routesConstants";

import { useTranslation } from "src/design-system/core/TranslationContext";
import { SHARED_LAYOUT_NAMESPACE, TOP_BAR_TK } from "../config";

const PosParameter: React.FC = () => {
    const history = useHistory();
    const { settings } = useSettings();
    const { t } = useTranslation(`${SHARED_LAYOUT_NAMESPACE}:${TOP_BAR_TK}`);

    const handleClick = (): void => {
        if (settings.possIds.length !== 1) {
            history.push(`${PATH_POS_LIST}/poss`);
        } else {
            history.push(`${PATH_POS_PARAMETER}/details`);
        }
    };

    return (
        <Tooltip title={t("posParams")}>
            <Badge color="default">
                <IconButton color="primary" onClick={handleClick}>
                    <SvgIcon fontSize="small">
                        <SettingsIcon />
                    </SvgIcon>
                </IconButton>
            </Badge>
        </Tooltip>
    );
};

export default PosParameter;
